import { Box, Button, Stack } from "@mui/material";
import React from "react";
import TabComp from "src/components/shared/TabComp";
import TableComp from "src/components/shared/table/TableComp";
import useAppGlobal from "src/context/useAppGlobal";
import BulkReturnProcessingDialog from "./dialog/BulkReturnProcessingDialog";
import useBulkReturnProcessing from "../utils/bulk-return-processing/useBulkReturnProcessing";
import useCreateBulkReturnProcessing from "src/hooks/orders/bulk-return-processing/useCreateBulkReturnProcessing";
import { ProductState } from "src/utils/productState";

export default function BulkReturnProcessing({ warehouseId, mutate }) {
  const { handleOpenDialog } = useAppGlobal();

  const { headers, bodyList, sortData, setPagi, pagi } = useBulkReturnProcessing(warehouseId);
  const { trigger: create } = useCreateBulkReturnProcessing();

  const handleOpen = async () => {
    const res = await create({
      body: {
        type: ProductState.NORMAL,
      },
    });
    if (res?.success) {
      return handleOpenDialog({
        size: "lg",
        disableBackdropClick: true,
        content: (
          <BulkReturnProcessingDialog
            returnedFormId={res?.data?._id}
            warehouseId={warehouseId}
            mutate={mutate}
          />
        ),
      });
    }
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={1.5}
        my={1.5}
      >
        <Box>
          <Button
            onClick={handleOpen}
            variant="contained"
          >
            Trả hàng hàng loạt
          </Button>
        </Box>
      </Stack>
      <Box mb={1.5}>
        <TabComp tabs={[{ id: 1, name: "Lịch sử trả hàng hàng loạt" }]} />
      </Box>
      <TableComp
        sortData={sortData}
        bodyList={bodyList}
        headers={headers}
        setPagi={setPagi}
        pagi={pagi}
      />
    </>
  );
}
